import { ValueEncoder } from "DiscoveryEngine.TS/Utils";
import { DtoBase } from "UvExplorerServer.Dtos.TS";
import { Theme } from "main/enums/theme.enum";

export class UserSettingsDto extends DtoBase {

    theme: Theme = Theme.Default;

    public Write(obj: any, context: any): void {

        super.Write(obj, context);

        obj.theme = ValueEncoder.EncodeInteger(this.theme);
    }

    public Read(obj: any, context: any): void {
        if(!obj.user_settings)
            throw new Error();
        obj = obj.user_settings;

        super.Read(obj, context);

        if(obj.theme !== undefined) {
            this.theme =  Theme[obj.theme as string] ;//ValueEncoder.DecodeInteger(obj.theme); // Integer? 
        }
    }
}